<template>
  <div v-if="loading">
    
  </div>
  <div v-else>

    <v-btn
      outlined
      class="text-none mb-4 pl-3 pr-3"
      color="gray12Color"
      style="background: var(--v-whiteColor-base);"
      @click="$router.push(`/sites/${site.id}/campaign/${campaign.id}/keyword-strategy`)"
    >
      <i class="material-icons-outlined mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">arrow_back</i> <span style="color: var(--v-blackColor-base);">Back to Keyword Strategy</span>
    </v-btn>
    
    <div v-if="report">
        
      <div>
        <div class="mb-2" style="color: var(--v-gray50Color-base); font-size: 1rem;">{{ site.name }}</div>

        <div class="card-big-title mb-4" style="color: var(--v-blackColor-base); font-weight: 700; font-size: 1.5rem;">
          Custom silo results
          <span class="material-icons video-tutorial-icon video-tutorial-icon-size"
            @click="() => {
              $store.commit('setCurrentVideoTutorialToDisplay', {
                title: 'How Pros Build Custom SEO Silos (Full Control)',
                videoLink: 'https://www.youtube.com/embed/d-as3x6gn7U',
                description: 'In this video, Heather Cumins, a Customer Success Manager at PageOptimizer Pro, shows you how to use POP’s Custom Silo to turn up to 10 target keywords or 20 competitor URLs into a fully ready, implementable content strategy.',
                time: '5m 27s'
              });
            }">
            videocam
          </span>
        </div>

        <div class="mb-4 d-flex gap10 align-center" style="color: var(--v-blackColor-base);">
          <span v-if="report.name" style="font-size: 0.9rem;">{{ report.name }} <span style="color: var(--v-grayColor-base);">•</span></span>
          <v-tooltip top color="black">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" style="text-decoration: underline; text-decoration-style: dashed;  font-size: 0.9rem;">
                {{ report?.topics?.length || 0 }} topic{{ (report?.topics?.length || 0) === 0 || (report?.topics?.length || 0) > 1 ? 's' : '' }}
              </span>
            </template>
            <div style="max-width: 350px;">{{ report?.topics.map(topics => topics.topic || topics.competitor).join(', ') }}</div>
          </v-tooltip>
          <span style="color: var(--v-grayColor-base);">•</span>
          <span style="font-size: 0.9rem;">Report ID #{{ report.id }}</span>
        </div>
        
        <div class="d-flex align-center justify-space-between gap10 mb-2">
          
          <div style="max-width: 500px; line-height: 1.6; font-size: 0.9rem;">
            Review keyword suggestions that POP has made for your silo and get keyword data for the ones that you like.
          </div>

          <div class="d-flex align-center gap10">
            <b-dropdown aria-role="list" position="is-bottom-left">
              <template #trigger>
                <v-btn
                  outlined
                  class="text-none"
                  color="gray12Color"
                  style="background: var(--v-whiteColor-base);"
                >
                  <i class="material-icons mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">school</i> <span style="color: var(--v-blackColor-base);">Working with results</span>
                </v-btn>
              </template>
    
              <b-dropdown-item custom style="width: 1250px;">
                <working-with-results-part />
              </b-dropdown-item>
            </b-dropdown>
  
            <v-btn
              outlined
              class="text-none"
              color="gray12Color"
              style="background: var(--v-whiteColor-base);"
              href="https://help.pageoptimizer.pro/article/difference-between-top-level-and-supporting-content-keywords"
              target="_blank"
            >
              <i class="material-icons mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">school</i> <span style="color: var(--v-blackColor-base);">How to use this dashboard?</span>
            </v-btn>
          </div>
          
        </div>
        
      </div>

      <div
        v-if="currentAsyncTask?.is_pending_or_in_progress"
        class="d-flex flex-column align-center pt-8 pb-8"
      >
        <div class="d-flex flex-column align-center" style="max-width: 500px; text-align: center;">
          <img src="/static/keyword-insight-processing-image.svg" width="315" height="222" class="mb-4" />
          <div class="mb-6" style="font-size: 1.2rem; font-weight: bold; line-height: 1.6; max-width: 400px;">Hang tight! Your silo’s on the way…</div>
    
          <v-progress-linear
            class="mb-4" 
            style="max-width: 300px;"
            rounded height="5"
            color="profileAnchorColor"
            :value="currentAsyncTask.task_status.value || 0">
          </v-progress-linear>

          <div style="font-size: 1rem; color: var(--v-gray50Color-base);">{{ currentAsyncTask.task_status.status === 'PENDING' ? 'Starting...' : currentAsyncTask.task_status.msg }}</div>
        </div>  
      </div>
        
      <div v-else class="pt-4">

        <v-card class="white-common-box mb-10" style="width: 100%; overflow: initial !important;">

          <!-- Controls -->
          
          <div
            style="padding: 15px 20px; border-bottom: 1px solid var(--v-grayColor-base);"
          >
            <div class="d-flex align-center justify-space-between gap10">

              <v-text-field
                class="table-search-field"
                outlined dense hide-details
                label="Search keywords"
                prepend-inner-icon="search"
                style="max-width: 300px;"
                v-model="search"
              />

              <!-- Filters Area -->

              <div class="d-flex align-center justify-end gap10">
                
                <div class="keyword-filter-area" style="border-color: var(--v-grayColor-base);">
                  <div style="border-color: var(--v-grayColor-base); color: var(--v-blackColor-base);">Keyword type</div>
                  <b-dropdown aria-role="list" position="is-bottom-left">
                    <template #trigger>
                      <div class="filter-btn" style="position:relative; color: var(--v-gray2Color-base); min-width: 130px;">
                        {{ keywordIntentFilter.length }} filter{{keywordIntentFilter.length === 1 ? '':'s'}} applied
                        <span class="material-icons-outlined">keyboard_arrow_down</span>
                      </div>
                    </template>
          
                    <b-dropdown-item custom style="width: 300px;">
                      <v-checkbox dense hide-details="auto" color="#007aff"
                        style="text-transform: capitalize;"
                        v-for="option in keywordIntentOptions" :key="option"
                        v-model="keywordIntentFilter" :value="option" :true-value="[]" :label="option"
                      />
                    </b-dropdown-item>
                  </b-dropdown>
                </div>

                <div class="keyword-filter-area" style="border-color: var(--v-grayColor-base);">
                  <div style="border-color: var(--v-grayColor-base); color: var(--v-blackColor-base);">Keyword source</div>
                  <b-dropdown aria-role="list" position="is-bottom-left">
                    <template #trigger>
                      <div class="filter-btn" style="position:relative; color: var(--v-gray2Color-base); min-width: 130px;">
                        {{ keywordSourceFilter.length }} filter{{keywordSourceFilter.length === 1 ? '':'s'}} applied
                        <span class="material-icons-outlined">keyboard_arrow_down</span>
                      </div>
                    </template>
          
                    <b-dropdown-item custom style="width: 400px;">
                      <v-checkbox dense hide-details="auto" color="#007aff"
                        v-for="option in keywordSourceOptions" :key="option"
                        v-model="keywordSourceFilter" :value="option" :true-value="[]" :label="option"
                      />
                    </b-dropdown-item>
                  </b-dropdown>
                </div>

              </div>

            </div>
          </div>

          <!-- Select all -->

          <div
            v-if="selectableTopics.length > 1"
            class="d-flex align-center justify-space-between gap10"
            style="padding: 15px 20px; border-bottom: 1px solid var(--v-grayColor-base); min-height: 70px;"
          >
            <div>
              <v-checkbox
                class="mt-0 pt-0 topic-checkbox"
                color="#007aff"
                hide-details="auto"
                :input-value="isAllSelected()"
                @change="toggleSelectAll()"
              >
                <template v-slot:label>
                  <div style="color: var(--v-blackColor-base); font-weight: 700;">Suggested keyword clusters</div>
                </template>
              </v-checkbox>
            </div>

            <div class="d-flex align-center gap10">
              <v-tooltip
                v-if="getTopicIdsWithSelectedKeywords().length > 1"
                top color="black"
                :disabled="!(isBulkButtonDisabled() || (isWhiteGloveUser && !isMissionControlSession))"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-btn
                      color="profileAnchorColor"
                      class="button-with-icon text-none whiteColor--text"
                      :disabled="isBulkButtonDisabled() || (isWhiteGloveUser && !isMissionControlSession)"
                      @click="() => hasUnlimitedAccess?startMetricsTask(getSelectedKeywordsForBulk()):(() => {showCostModalFor = 'bulk'})()"
                    >
                      <i class="material-icons-outlined mr-2">query_stats</i>
                      <span>Get keyword data for all topic selections ({{ getSelectedKeywordsForBulk().length }})</span>
                    </v-btn>
                  </div>
                </template>
                <div style="text-align: center;">Requires at least 10 keywords to be selected per topic</div>
              </v-tooltip>
            </div>
          </div>

          <!-- Topics -->

          <div
            v-for="topic in report?.topics || []"
            :key="topic.id"
            :class="[{'is-expanded': expandedTopicsIds.includes(topic.id)}]"
          >

            <div
              class="topic-section-header"
              style="padding: 15px 20px;"
            >
              <div class="d-flex align-center justify-space-between gap10">

                <div class="d-flex align-center gap10">
                  <i
                    class="material-icons"
                    style="cursor: pointer; padding:4px; font-size: 1.3rem; color: var(--v-gray2Color-base);"
                    @click="() => { toggleExpandedTopic(topic.id) }"
                  >{{ expandedTopicsIds.includes(topic.id) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</i>

                  <span
                    v-if="topic.hasMetrics || currentAsyncTasksForTopicMetricsMap?.[topic.id]?.is_pending_or_in_progress"
                  >
                    {{ topic.topic || topic.competitor }}
                  </span>
                  <v-checkbox
                    v-else
                    light
                    class="mt-0 pt-0 topic-checkbox"
                    color="#007aff"
                    hide-details="auto"
                    :input-value="isAllSelectedForTopic(topic)"
                    @change="toggleSelectAllForTopic(topic)"
                  >
                    <template v-slot:label>
                     <div style="color: var(--v-blackColor-base);">{{ topic.topic || topic.competitor }}</div>
                    </template>
                  </v-checkbox>

                  <v-tooltip
                    top color="black"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        class="tag"
                        :style="{'color': '#6C6E71', 'background-color': '#EAECF0', width: '35px'}"
                        v-bind="attrs" v-on="on"
                      >
                        {{ topic.result.length }}
                      </span>
                    </template>
                    <div style="text-align: center;">{{ topic.result.length }} keywords in this cluster</div>
                  </v-tooltip>
                </div>

                <div class="d-flex align-center gap10">
                  <v-btn
                    v-if="topic.hasMetrics"
                    outlined
                    class="text-none"
                    color="gray12Color"
                    style="background: var(--v-whiteColor-base);"
                    @click="$router.push(`/sites/${site.id}/campaign/${campaign.id}/keyword-strategy/custom-silo/${report.id}/metrics/${topic.id}`)"
                  >
                    <i class="material-icons-outlined mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">remove_red_eye</i> <span style="color: var(--v-blackColor-base);">View keyword data</span>
                  </v-btn>
                  <v-tooltip
                    v-else
                    top color="black"
                    :disabled="!(currentAsyncTasksForTopicMetricsMap?.[topic.id]?.is_pending_or_in_progress || getSelectedKeywordsForTopic(topic).length < 10 || getSelectedKeywordsForTopic(topic).length > 100 || (isWhiteGloveUser && !isMissionControlSession))"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-btn
                          color="profileAnchorColor"
                          class="button-with-icon text-none whiteColor--text"
                          :disabled="currentAsyncTasksForTopicMetricsMap?.[topic.id]?.is_pending_or_in_progress || getSelectedKeywordsForTopic(topic).length < 10 || getSelectedKeywordsForTopic(topic).length > 100 || (isWhiteGloveUser && !isMissionControlSession)"
                          :loading="currentAsyncTasksForTopicMetricsMap?.[topic.id]?.is_pending_or_in_progress"
                          @click="() => hasUnlimitedAccess?startMetricsTask(getSelectedKeywordsForTopic(topic)):(() => {showCostModalFor = topic})()"
                        >
                          <i class="material-icons-outlined mr-2">query_stats</i>
                          <span>Get keyword data <template v-if="getSelectedKeywordsForTopic(topic).length">({{ getSelectedKeywordsForTopic(topic).length }})</template></span>
                        </v-btn>
                      </div>
                    </template>
                    <div style="text-align: center;">Requires at least 10 keywords to be selected</div>
                  </v-tooltip>

                  <table-pdf-csv-download
                    btnStyle="min-width: initial; padding: 0 8px;"
                    btnLabel="Download"
                    tooltipPosition="is-left"
                    :iconOnly="true"
                    title="Custom Silo"
                    :fileName="`CustomSilo_${report?.id}_${topic?.id}`"
                    :columns="downloadableTableColumns"
                    :rows="applyFilters(topic.result)"
                  ></table-pdf-csv-download>
                </div>

              </div>
            </div>

            <div
              v-if="expandedTopicsIds.includes(topic.id)"
              class="topic-section-content"
              style="padding: 28px;"
            >
              
              <b-table
                class="keywords-table"
                :data="applyFilters(topic.result)"
                :checkable="!currentAsyncTasksForTopicMetricsMap?.[topic.id]?.is_pending_or_in_progress"
                :checked-rows.sync="selectedKeywords"
                :checkbox-type="'is-info'"
                :is-row-checkable="(row) => !row.hasMetrics"
                :default-sort-direction="'desc'"
                :default-sort="'keywordTypeSuggestion'"
              >
                <template slot-scope="props">

                  <b-table-column field="keyword" label="Keyword" sortable>
                    <div class="d-flex align-center gap10">
                      {{ props.row.keyword }}
                      <span
                        v-if="props.row.hasMetrics"
                        class="tag"
                        style="background-color: #E1F6F2; color: #027E67; font-weight: 700; font-size: 0.75rem; cursor: pointer;"
                        @click="$router.push({path: `/sites/${site.id}/campaign/${campaign.id}/keyword-strategy/custom-silo/${report.id}/metrics/${topic.id}`, query: {highlight: props.row.id}})"
                      ><i class="material-icons-outlined mr-1" style="font-size: 1rem;">check</i> View data</span>
                    </div>
                  </b-table-column>

                  <b-table-column field="keywordTypeSuggestion" label="AI-suggested Keyword Type" sortable :custom-sort="handleKeywordTypeSuggestionSort">
                    {{ props.row.isTopLevelKeywordSuggestion ? 'Top Level keyword ' : '' }}{{ props.row.isSupportingKeywordSuggestion ? 'Supporting keyword ' : '' }}
                  </b-table-column>

                  <b-table-column field="keyword_intent" label="Keyword Intent" sortable>
                    <span style="text-transform: capitalize;">{{ props.row.keyword_intent }}</span>
                  </b-table-column>

                  <b-table-column field="source" label="Keyword Source" sortable>
                    {{ props.row.source }}
                  </b-table-column>
                </template>
              </b-table>
            </div>
            
          </div>


        </v-card>

        <div
          class="flex white-selected-box justify-space-between mt-4 gap20"
          style="min-width: 450px; height: 4.875rem;"
          v-if="report?.topics?.filter?.(topic => topic.hasMetrics)?.length && filteredSelectedKeywords?.length && !(isWhiteGloveUser && !isMissionControlSession)"
        >
          <div class="flex">
            <div class="box-primary-bg d-flex align-center">
              <div class="count-value px-5">
                {{ filteredSelectedKeywords?.length || 0 }}
              </div>
            </div>
            <div class="px-3 d-flex align-center">
              <div class="selected-text">Item{{ filteredSelectedKeywords?.length === 1 ? '':'s'}} selected</div>
            </div>
          </div>  
          <div class="d-flex flex-wrap align-center">
            <div class="flex gap15 align-center fill-height">
              <span
                class="flex flex-column align-center cursor-pointer w78"
                @click="() => hasUnlimitedAccess?startMetricsTask(getSelectedKeywordsForBulk()):(() => {showCostModalFor = 'bulk'})()"
              >
                <i class="material-icons-outlined orange-color">query_stats</i>
                <div class="action-title">Get keyword data</div>
              </span>
              <div
                class="cross-container flex justify-center align-center fill-height px-5"
              >
                <i @click="selectedKeywords = []" class="material-icons cursor-pointer">close</i>
              </div>
            </div>
          </div>
        </div>


        <div v-if="showCostModalFor" class="modal keyword-data-cost-modal" :class="{'is-active': true}">
          <div class="modal-background" @click.stop="showCostModalFor = null"></div>
          <div class="modal-content">
            <div class="box modal-container">
              <div class="modal-content-root">
                <p class="title-font is-size-4 mainColor--text">Get keyword data</p>
                <div class="mainColor--text message-text">
                  <div class="mb-2">You’ve selected <span class="font-weight-bold">{{ filteredSelectedKeywords.length }} keyword{{filteredSelectedKeywords.length >1 ?'s':''}}</span> across <span class="font-weight-bold">{{ getTopicIdsWithSelectedKeywords().length }} topic{{getTopicIdsWithSelectedKeywords().length >1 ?'s':''}}</span>.</div>
                  <div class="mb-1">We’ll retrieve detailed metrics for the selected keywords, including:</div>
                  <ul class="mb-2" style="list-style: initial;">
                    <li>Keyword Difficulty Score</li>
                    <li>Search Volume</li>
                    <li>Search Volume trend</li>
                    <li>Ranking URL and Position</li>
                    <li>Keyword Score</li>
                    <li>SEO Competitiveness Index (SCI)</li>
                    <li>AllinTitle</li>
                    <li>KGR Score</li>
                  </ul>
    
                  <template>
                    <br/>
                    This action will consume <span class="font-weight-bold">{{ getCostForBulk() }} POP Credit{{getCostForBulk >1 ?'s':''}}</span>. Click <span class="font-weight-bold">Get Data</span> to proceed.
                  </template>
                </div>
                <div class="d-flex justify-end gap10 mt-5">
                  <v-btn rounded outlined color="mainColor"
                    class="text-none"
                    @click.stop="() => {
                      showCostModalFor = null;
                    }">
                    <span>Cancel</span>
                  </v-btn>
                  <v-btn rounded color="profileAnchorColor"
                    class="whiteColor--text text-none"
                    @click.stop="() => {
                      if (showCostModalFor === 'bulk') {
                        startMetricsTask(getSelectedKeywordsForBulk())
                      } else {
                        startMetricsTask(getSelectedKeywordsForTopic(showCostModalFor))
                      }
                    }">
                    <span>Get data</span>
                  </v-btn>
                  
                </div>
              </div>
            </div>
            <button
              class="custom-modal-close-btn"
              aria-label="close"
              @click="() => (showCostModalFor = null)">
              <i class="material-icons">close</i>
            </button>
          </div>
        </div>
        

      </div>
      

    </div>

    <div v-else>
      <div class="card-big-title mb-8 d-flex gap10">
        No report found
      </div>
    </div>

  </div>
</template>

<script>
import TablePdfCsvDownload from '@/components/Campaigns/TablePdfCsvDownload.vue';
import WorkingWithResultsPart from './WorkingWithResultsPart.vue';
import rockyKeywordScreenMixin, {
  KEYWORD_SCREENS,
  MAX_LIST_ITEMS,
  MAX_TABLE_ROWS,
  summarize,
  short as rockyShort,
} from '../../../rockyKeywordScreen.js';

import {
  get_keyword_research_metrics_price_for_num_of_keywords,
} from "@/components/plans_constants"


const keywordSourceOptions = [
  "Google Suggestions",
  "Related Keywords",
  "Keyword Suggestions",
  "AI Generated",
  "AI-Suggested Supporting Keywords",
  "People Also Ask",
]

const keywordIntentOptions = [
  "informational",
  "navigational",
  "commercial",
  "transactional",
]


export default {
  mixins: [rockyKeywordScreenMixin],
  props: ['site', 'campaign', 'hasUnlimitedAccess', 'isWhiteGloveUser', 'isMissionControlSession', 'reloadUser'],
  components: {
    TablePdfCsvDownload,
    WorkingWithResultsPart
  },
  data () {
    return {
      loading: true,
      report: null,
      expandedTopicsIds: [],
      selectedKeywords: [],
      search: '',
      keywordSourceFilter: [],
      keywordIntentFilter: [],
      showCostModalFor: null,
    }
  },
  computed: {
    asyncTasks() {
      return this.$store.state.asyncTasks
    },
    currentAsyncTask() {
      return this.asyncTasks.filter(task => task.type.startsWith('SiloResearch.custom_silo_get_keywords_task') && task.record_id === this.report?.id)[0]
    },
    currentAsyncTasksForTopicMetrics() {
      return this.asyncTasks.filter(task => task.type.startsWith('SiloResearch.custom_silo_get_metrics_task') && (this.report?.topics || []).map(topic => topic.id).includes(task.record_id))
    },
    currentAsyncTasksForTopicMetricsMap() {
      return Object.fromEntries(this.currentAsyncTasksForTopicMetrics.map(task => [task.record_id, task]))
    },
    keywordSourceOptions() {
      return keywordSourceOptions
    },
    keywordIntentOptions() {
      return keywordIntentOptions
    },
    areFiltersApplied() {
      if (
        this.search
        || this.keywordIntentFilter.length
        || this.keywordSourceFilter.length
      ) {
        return true
      }
      return false
    },
    filteredSelectedKeywords() {
      return this.applyFilters(this.selectedKeywords)
    },
    selectableTopics() {
      return this.report.topics.filter(topic => {
        if (topic.hasMetrics || this.currentAsyncTasksForTopicMetricsMap?.[topic.id]?.is_pending_or_in_progress) {
          return false
        }
        return true
      })
    },
    downloadableTableColumns() {
      return [
        { key: "keyword", label: "Keyword", value: "keyword", align: 'start' },
        { 
          key: "keywordTypeSuggestion",
          label: "AI-suggested Keyword Type",
          value: "keywordTypeSuggestion",
          downloadButtonValue: (row) => {
            if (row.isTopLevelKeywordSuggestion) {
              return 'Top-Level Keyword'
            }
            if (row.isSupportingKeywordSuggestion) {
              return 'Supporting Keyword'
            }
            return ''
          },
        },
        {
          key: "keyword_intent", label: "Keyword Intent", value: "keyword_intent",
        },
        {
          key: "source", label: "Keyword Source", value: "source",
        },
      ]
    }
  },
  watch: {
    // Rocky's refresh signal (PopAssistantButton.handleRefresh). A research
    // POP Pilot started through the API is not in the store's task list, so
    // currentAsyncTask never flips here; reload the report when asked.
    '$store.state.triggerRockyRefresh': function () {
      this.loadReport()
    },
    report () { this.emitRockyKeywordScreen() },
    expandedTopicsIds () { this.emitRockyKeywordScreenDebounced() },
    selectedKeywords () { this.emitRockyKeywordScreenDebounced() },
    search () { this.emitRockyKeywordScreenDebounced() },
    keywordSourceFilter () { this.emitRockyKeywordScreenDebounced() },
    keywordIntentFilter () { this.emitRockyKeywordScreenDebounced() },
    currentAsyncTask: function (newVal, oldVal) {
      if (newVal?.is_completed && oldVal && newVal?.is_completed !== oldVal?.is_completed) {
        this.reloadUser()
        this.loadReport()
      }
      this.emitRockyKeywordScreenDebounced()
    },
    currentAsyncTasksForTopicMetrics: function (newVal, oldVal) {
      let reload = false

      const oldValMap = Object.fromEntries(oldVal.map(task => [task.id, task]))

      for (let index = 0; index < newVal.length; index++) {
        const newValTask = newVal[index];
        const oldValTask = oldValMap?.[newVal[index].id];
        if (newValTask.is_completed && oldValTask && newValTask?.is_completed !== oldValTask?.is_completed) {
          reload = true
          break
        }
      }

      if (reload) {
        this.reloadUser()
        this.loadReport()
      }
    }
  },
  methods: {
    get_keyword_research_metrics_price_for_num_of_keywords(num_of_keywords) {
      return get_keyword_research_metrics_price_for_num_of_keywords(num_of_keywords)
    },
    handleKeywordTypeSuggestionSort(a, b, isAsc) {
      const getKeywordTypeSortingValue = (row) => {
        if (row.isTopLevelKeywordSuggestion) return 3
        if (row.isSupportingKeywordSuggestion) return 2
        return 1
      }
      const aVal = getKeywordTypeSortingValue(a);
      const bVal = getKeywordTypeSortingValue(b);

      if (isAsc) {
        return aVal - bVal;
      }
      return bVal - aVal;
    },
    applyFilters(keywords) {
      return keywords.filter(keyword => {
        let include = true
        if (this.search && !keyword.keyword.toLowerCase().includes(this.search.toLowerCase())) {
          return false
        }

        if (this.keywordSourceFilter.length && !this.keywordSourceFilter.includes(keyword.source)) {
          return false
        }

        if (this.keywordIntentFilter.length && !this.keywordIntentFilter.includes(keyword.keyword_intent)) {
          return false
        }

        return include
      })
    },
    toggleExpandedTopic(topicId) {
      if (this.expandedTopicsIds.includes(topicId)) {
        this.expandedTopicsIds = this.expandedTopicsIds.filter(id => id !== topicId)
      } else {
        this.expandedTopicsIds = [
          ...this.expandedTopicsIds,
          topicId
        ]
      }
    },
    isBulkButtonDisabled() {
      const selectedTopicIds = this.getTopicIdsWithSelectedKeywords()
      const selectedTopics = this.report.topics.filter(topic => selectedTopicIds.includes(topic.id)) 
      for (var i = 0; i < selectedTopics.length; i++) {
        if (
          this.getSelectedKeywordsForTopic(selectedTopics[i]).length < 10
          || this.getSelectedKeywordsForTopic(selectedTopics[i]).length > 100
          || this.currentAsyncTasksForTopicMetricsMap?.[selectedTopics[i].id]?.is_pending_or_in_progress
        ) {
          return true
        }
      }
      return false
    },
    getCostForTopic(topic) {
      return this.get_keyword_research_metrics_price_for_num_of_keywords(
        this.getSelectedKeywordsForTopic(topic).length
      )
    },
    getCostForBulk() {
      return this.report.topics.filter(topic => this.getTopicIdsWithSelectedKeywords().includes(topic.id)).map(topic => this.getCostForTopic(topic)).reduce((partialSum, a) => partialSum + a, 0)
    },
    getSelectedKeywordsForBulk() {
      let result = []
      for (var i = 0; i < this.report.topics.length; i++) {
        result = [
          ...result,
          ...this.getSelectedKeywordsForTopic(this.report.topics[i])
        ]
      }
      return result
    },
    getSelectedKeywordsForTopic(topic) {
      return this.filteredSelectedKeywords.filter(keyword => keyword.topicId === topic.id)
    },
    getTopicIdsWithSelectedKeywords() {
      return [...new Set(this.filteredSelectedKeywords.map(item => item.topicId))]
    },
    isAllSelectedForTopic(topic) {
      const filteredTopicKeywords = this.applyFilters(topic.result)
      const filteredSelectedTopicKeywords = this.getSelectedKeywordsForTopic(topic)
      return filteredTopicKeywords.length === filteredSelectedTopicKeywords.length
    },
    isAllSelected() {
      for (var i = 0; i < this.report.topics.length; i++) {
          if (!this.isAllSelectedForTopic(this.report.topics[i])) {
            return false
          }
      }
      return true
    },
    selectAllForTopic(topic) {
      const filteredKeywords = this.applyFilters(topic.result)
      const topicKeywordsIds = filteredKeywords.map(item => item.id)
      this.selectedKeywords = [
        ...this.selectedKeywords.filter(item => !topicKeywordsIds.includes(item.id)),
        ...filteredKeywords
      ]
    },
    toggleSelectAllForTopic(topic) {
      if (this.isAllSelectedForTopic(topic)) {
        this.selectedKeywords = this.selectedKeywords.filter(item => item.topicId !== topic.id)
      } else {
        this.selectAllForTopic(topic)
      }
    },
    toggleSelectAll() {
      if (this.isAllSelected()) {
        this.selectedKeywords = []
      } else {
        this.selectedKeywords = []
        this.report.topics.forEach(topic => {
          this.selectAllForTopic(topic)
        })
      }
    },
    startMetricsTask (keywords) {
      this.showCostModalFor = null;
      this.selectedKeywords = []
      const postData = {
        keywords: keywords.map(keyword => ({
          id: keyword.id,
          topicId: keyword.topicId,
        })),
      }

      this.isStartingAsyncTask = true
      this.$store.dispatch('siloResearchCustomSiloStartMetricsTask', postData)
      .then(response => {
        if (response.data) {
          if (response.data.status == 'SUCCESS') {
            this.$store.commit('triggerAsyncTasksRefresh');
            this.reloadUser()
            this.isAwaitingAsyncTaskStatus = true;
            this.isStartingAsyncTask = false
          } else if (response.data.status == 'FAILURE') {
            this.$notify({
              group: 'info', type: 'error',
              text: response?.data?.msg || 'Failed to analyze keyword research data'
            })
            this.isStartingAsyncTask = false
          }
        }
      })
      .finally(() => {
        this.isStartingAsyncTask = false
      })
    },
    loadReport () {
      return this.$store.dispatch('siloResearchSingle', {
        id: this.$route.params.id,
        includeTopics: 1,
        includeKeywords: 1,
      })
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.report = response.data.research
        }
      })
    },
    // Rocky snapshot: topic overview always; keyword rows only for expanded
    // topics (that's what the UI shows), filtered exactly like the tables.
    buildRockyScreenData () {
      const generating = !!this.currentAsyncTask?.is_pending_or_in_progress
      const topics = this.report?.topics || []
      let status = 'loading'
      if (!this.loading) {
        if (generating) status = 'generating'
        else if (topics.length) status = 'ready'
        else status = 'empty'
      }
      const data = {}
      if (this.report) {
        data.name = rockyShort(this.report.name)
        data.topics = summarize(topics, (t) => ({
          topicId: String(t.id),
          label: rockyShort(t.topic || t.competitor),
          keywordCount: (t.result || []).length,
          hasMetrics: !!t.hasMetrics,
          expanded: this.expandedTopicsIds.includes(t.id),
          metricsTaskInProgress: !!this.currentAsyncTasksForTopicMetricsMap?.[t.id]?.is_pending_or_in_progress,
          selectedCount: this.getSelectedKeywordsForTopic(t).length,
        }), MAX_LIST_ITEMS)
        const expandedRows = []
        topics.forEach((t) => {
          if (!this.expandedTopicsIds.includes(t.id)) return
          this.applyFilters(t.result || []).forEach((k) => expandedRows.push({ topic: t, row: k }))
        })
        data.rows = summarize(expandedRows, ({ topic, row }) => ({
          topicId: String(topic.id),
          keyword: rockyShort(row.keyword),
          intent: row.keyword_intent != null ? row.keyword_intent : null,
          source: row.source != null ? row.source : null,
          suggestedType: row.isTopLevelKeywordSuggestion ? 'top_level' : (row.isSupportingKeywordSuggestion ? 'supporting' : null),
          hasMetrics: !!row.hasMetrics,
        }), MAX_TABLE_ROWS)
        data.viewState = {
          search: rockyShort(this.search),
          sourceFilters: this.keywordSourceFilter,
          intentFilters: this.keywordIntentFilter,
          selectedKeywordCount: this.selectedKeywords.length,
        }
      }
      if (generating) {
        data.progressPct = this.currentAsyncTask?.task_status?.value ?? null
        data.progressMsg = rockyShort(this.currentAsyncTask?.task_status?.msg)
      }
      return {
        screen: KEYWORD_SCREENS.CUSTOM_SILO_DETAIL,
        status,
        loading: this.loading || generating,
        recordIds: { siloResearchId: this.$route.params.id },
        data,
      }
    },
  },
  mounted () {
    this.emitRockyKeywordScreen()
    this.loadReport()
    .finally(() => {
      this.loading = false
      this.emitRockyKeywordScreen()
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./../../styles.scss";

.topic-section-header {
  border-bottom: 1px solid var(--v-grayColor-base);
}

.topic-section-content {
  border-bottom: 1px solid var(--v-grayColor-base);
}

.is-expanded {
  .topic-section-header {
    background-color: #f7f5fb;
  }
}

.v-application.theme--dark {
  .is-expanded {
    .topic-section-header {
      background-color: #444444;
    }
  }
}

::v-deep .keywords-table {
  border: 1px solid var(--v-gray12Color-base);
  border-radius: 5px;

  th, td {
    padding: 12px !important;
    color: var(--v-blackColor-base);
  }

  th {
    border-width: 0 0 1px !important;
    justify-content: center !important;
    width: 25%;
  }

  th > * {
    color: var(--v-blackColor-base);
  }

  th.checkbox-cell, td.checkbox-cell {
    padding-left: 0.75em !important;
    padding-right: 0.75em !important;
  }

  td.checkbox-cell .b-checkbox.is-disabled {
    visibility: hidden;
  }
  
  tbody {
    .url-cell {
      border-right: 1px solid var(--v-grayColor-base);
      
      /* this truncates long url parts that do not wrap into new lines */
      min-width: 250px;
      max-width: 700px;
      text-overflow: ellipsis;
      overflow: hidden;

      a {
        color: var(--v-link15Color-base);
        font-weight: 700;
      }
    }
  }

  .b-checkbox.checkbox input[type="checkbox"] + .check {
    border-width: 1px !important;
    border-color: var(--v-gray12Color-base);
  }
}

.keyword-filter-area {
  display: flex;
  align-items: center;
  min-height: 36px;
  border: 1px solid var(--v-mainColor-base);
  border-radius: 5px;
  & > div {
    padding: 7px 10px;
    color: var(--v-mainColor-base);
    &:first-child {
      border-right: 1px solid var(--v-mainColor-base);
    }
  }
  span[class^='material-icons'] {
    font-size: 1rem;
  }

  .filter-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    text-wrap: nowrap;
    cursor: pointer;
  }
}

.white-selected-box {
  background-color: var(--v-cardBg-base);
  border-radius: 0.313rem;
  box-shadow: 0px 2px 7px 0px #00000024;

  position: fixed;
  bottom: 5px; /* Distance from the bottom of the screen */
  left: 50%;
  transform: translateX(-50%); /* Centers the div horizontally */
  z-index: 1000; /* Ensures it's above other elements */
  animation: fadein 0.5s, fadeout 0.5s 2.5s; 
  
  .box-primary-bg {
    background-color: var(--v-profileAnchorColor-base);
    border-top-left-radius: 0.313rem;
    border-bottom-left-radius: 0.313rem;
  }

  .count-value {
    color: var(--v-cardBg-base);
    font-size: 1.375rem;
    font-weight: 500;
  }

  .selected-text {
    font-size: 1rem;
    font-weight: 500;
    color: var(--v-primary-base);
  }

  .action-title {
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--v-primary-base);
    text-align: center;
  }

  .flip-icon {
    transform: scaleX(-1);
  }
  
  .orange-color {
    color: var(--v-profileAnchorColor-base);
  }

  .cross-container {
    border-left: 1.5px solid var(--v-grayColor-base);
  }

  i {
    font-size: 1.75rem;
  }
}

::v-deep .topic-checkbox {
  .v-icon {
    color: var(--v-gray12Color-base);
  }
}

::v-deep .table-search-field {
  .v-icon {
    color: var(--v-gray36Color-base);
  }
  .v-label {
    color: var(--v-gray36Color-base);
    font-size: 0.85rem;
  }
  fieldset {
    border-color: var(--v-gray12Color-base);
  }
}
</style>